import React, { FC } from 'react';
import styled from 'styled-components';
import { LogoLeftPanel } from 'src/common/images/LogoLeftPanel';
import { HomepageRoute, LogoutRoute } from 'src/public/publicRoutes';
import LogoutIcon from 'src/assets/icons/LogoutIcon';
import { LeftPanelIcon, LeftPanelItem, LeftPanelTitle } from 'src/common/components/LeftPanelItem';
import { useSelector } from 'react-redux';
import { layoutActivePanelCategorySelector } from 'src/state/layout/layoutSelectors';
import { userProfileMenuItems } from 'src/user/common/models/userProfileMenuItem';
import { GatsbyLink } from 'src/common/migration/GatsbyLink';
import { PartnerLogoDesktop } from 'src/common/components/PartnerLogoDesktop';
import { translatedPathnames } from 'src/config/routes';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 3.8125rem);
  position: sticky;
  top: 0;
`;

const Wrapper = styled.div`
  padding-bottom: 4rem;
  width: 100%;
`;

const Logout = styled.div`
  margin-top: auto;
  padding: 2.5rem 0;
`;

const StyledLink = styled(GatsbyLink)`
  display: inline-block;
  margin: 2.375rem 0 1.5625rem 2.125rem;
`;

export const UserPageDesktopMenu: FC = () => {
  const activeCategory = useSelector(layoutActivePanelCategorySelector);

  return (
    <Wrapper>
      <Container>
        <StyledLink to={HomepageRoute}>
          <LogoLeftPanel />
        </StyledLink>

        <PartnerLogoDesktop />

        {userProfileMenuItems.map((category) => (
          <LeftPanelItem
            $active={
              activeCategory
                ? (translatedPathnames[activeCategory] ?? activeCategory) === category.id
                : false
            }
            as={GatsbyLink}
            key={category.id}
            to={category.url}
          >
            <LeftPanelIcon as={category.icon} size={18} />
            <LeftPanelTitle dangerouslySetInnerHTML={{ __html: category.title }} />
          </LeftPanelItem>
        ))}

        <Logout>
          <LeftPanelItem $active={false} as={GatsbyLink} to={LogoutRoute}>
            <LeftPanelIcon as={LogoutIcon} size={18} />
            <LeftPanelTitle>Wyloguj się</LeftPanelTitle>
          </LeftPanelItem>
        </Logout>
      </Container>
    </Wrapper>
  );
};
